import { localStorageKeys } from "../constants";

export const hideSelectorModal = (
  showOnLogin: boolean,
  setLocalStorage: (context: string, name: string, payload: any) => void,
) => {
  if (!showOnLogin) {
    setLocalStorage(
      localStorageKeys.accountselector.context,
      localStorageKeys.accountselector.names.hideSelectorModal,
      true,
    );
  }
};
